var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4949 0C12.9262 0 13.3199 0.24375 13.5074 0.632812L16.7231 7.25625L23.9043 8.31562C24.3262 8.37656 24.6777 8.67188 24.809 9.07969C24.9402 9.4875 24.8324 9.92812 24.5324 10.2281L19.3246 15.3937L20.5527 22.6875C20.6231 23.1094 20.4496 23.5359 20.1027 23.7891C19.7559 24.0422 19.2918 24.0703 18.9168 23.8688L12.4949 20.4375L6.07774 23.8641C5.69805 24.0656 5.23868 24.0375 4.8918 23.7844C4.54493 23.5312 4.36681 23.1047 4.43712 22.6828L5.66524 15.3891L0.45743 10.2281C0.152742 9.92812 0.0496174 9.48281 0.180867 9.07969C0.312117 8.67656 0.66368 8.38125 1.08555 8.31562L8.2668 7.25625L11.4824 0.632812C11.6746 0.24375 12.0637 0 12.4949 0ZM12.4949 3.70312L10.034 8.775C9.86993 9.10781 9.55587 9.34219 9.18555 9.39844L3.64024 10.2141L7.6668 14.2031C7.92462 14.4609 8.04649 14.8266 7.98555 15.1875L7.03399 20.7984L11.9652 18.1641C12.2981 17.9859 12.6965 17.9859 13.0246 18.1641L17.9559 20.7984L17.009 15.1922C16.9481 14.8313 17.0652 14.4656 17.3277 14.2078L21.3543 10.2188L15.809 9.39844C15.4434 9.34219 15.1246 9.1125 14.9606 8.775L12.4949 3.70312Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineStarIcon);
export default __webpack_public_path__ + "static/media/line-star-icon.8fcd1a142554e587c99e2e3b29bbfc09.svg";
export { ForwardRef as ReactComponent };